import axios from "axios";
import { call, put, takeLatest } from "redux-saga/effects";
import { buildApiUrl, getAuthHeaders } from "../../../api/apiClient";
import {
  fetchSensorTypesFailure,
  fetchSensorTypesStart,
  fetchSensorTypesSuccess,
} from "../../../store/features/customer/sensorTypes/sensorTypesSlice";

const URL = buildApiUrl("/api/v1/instruments/sensor_type/");

const getSensorTypesApi = async (accessToken) => {
  try {
    const response = await axios.get(URL, {
      headers: getAuthHeaders(accessToken),
    });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    throw new Error(errorMessage);
  }
};

function* fetchSensorTypesSaga(action) {
  try {
    const { accessToken } = action.payload;
    const sensorTypesData = yield call(getSensorTypesApi, accessToken);
    yield put(fetchSensorTypesSuccess(sensorTypesData));
  } catch (error) {
    yield put(fetchSensorTypesFailure(error.message));
  }
}

export default function* sensorTypesSaga() {
  yield takeLatest(fetchSensorTypesStart.type, fetchSensorTypesSaga);
}
